export const targetGroupTranslationKeyMap: { [targetGroup: string]: string } = {
    male: 'BRAND_PRODUCTS.GENDER.MALE',
    female: 'BRAND_PRODUCTS.GENDER.FEMALE',
    unisex: 'BRAND_PRODUCTS.GENDER.UNISEX'
};

export const orderAreaTargetGroupTranslationKeyMap: { [targetGroup: string]: string } = {
    womenswear: 'BRAND_PRODUCTS.TARGET_GROUP.WOMENSWEAR',
    menswear: 'BRAND_PRODUCTS.TARGET_GROUP.MENSWEAR',
    teens: 'BRAND_PRODUCTS.TARGET_GROUP.TEENS',
    babies: 'BRAND_PRODUCTS.TARGET_GROUP.BABIES',
    newborn: 'BRAND_PRODUCTS.TARGET_GROUP.NEWBORN',
    unisex: 'BRAND_PRODUCTS.TARGET_GROUP.UNISEX',
    kids: 'BRAND_PRODUCTS.TARGET_GROUP.KIDS'
};

export const activeStatusTranslationKeyMap: { [status: string]: string } = {
    active: 'SMART_REPLENISHMENT_AUTO_RESTOCK.STATUS.ACTIVE',
    scheduled: 'SMART_REPLENISHMENT_AUTO_RESTOCK.STATUS.SCHEDULED',
    inactive: 'SMART_REPLENISHMENT_AUTO_RESTOCK.STATUS.INACTIVE',
    expired: 'SMART_REPLENISHMENT_AUTO_RESTOCK.STATUS.EXPIRED'
};

export const colorTranslationKeyMap: { [color: string]: string } = {
    black: 'COLOR.BLACK',
    white: 'COLOR.WHITE',
    blue: 'COLOR.BLUE',
    brown: 'COLOR.BROWN',
    gray: 'COLOR.GRAY',
    beige: 'COLOR.BEIGE',
    green: 'COLOR.GREEN',
    pink: 'COLOR.PINK',
    red: 'COLOR.RED',
    orange: 'COLOR.ORANGE',
    yellow: 'COLOR.YELLOW',
    violet: 'COLOR.VIOLET',
    gold: 'COLOR.GOLD',
    silver: 'COLOR.SILVER',
    multicolor: 'COLOR.MULTICOLOR'
};

export const categoryTranslationKeyMap: { [category: string]: string } = {
    skirts: 'PRODUCT_CATEGORY.CLOTHES.SKIRTS.NAME',
    dresses: 'PRODUCT_CATEGORY.CLOTHES.DRESSES.NAME',
    indoorJackets: 'PRODUCT_CATEGORY.CLOTHES.INDOORJACKETS.NAME',
    outdoorJackets: 'PRODUCT_CATEGORY.CLOTHES.OUTDOORJACKETS.NAME',
    shirts: 'PRODUCT_CATEGORY.CLOTHES.SHIRTS.NAME',
    pullover: 'PRODUCT_CATEGORY.CLOTHES.PULLOVER.NAME',
    blousesChemises: 'PRODUCT_CATEGORY.CLOTHES.BLOUSESCHEMISES.NAME',
    suitsBlazers: 'PRODUCT_CATEGORY.CLOTHES.SUITSBLAZERS.NAME',
    vests: 'PRODUCT_CATEGORY.CLOTHES.VESTS.NAME',
    pants: 'PRODUCT_CATEGORY.CLOTHES.PANTS.NAME',
    denimPants: 'PRODUCT_CATEGORY.CLOTHES.DENIMPANTS.NAME',
    underwear: 'PRODUCT_CATEGORY.UNDERCLOTHES.NAME',
    sleepwear: 'PRODUCT_CATEGORY.UNDERCLOTHES.SLEEPWEAR.NAME',
    swimwear: 'PRODUCT_CATEGORY.UNDERCLOTHES.SWIMWEAR.NAME',
    headdress: 'PRODUCT_CATEGORY.UNDERCLOTHES.HEADDRESS.NAME',
    hosiery: 'PRODUCT_CATEGORY.UNDERCLOTHES.HOSIERY.NAME',
    shoeFlats: 'PRODUCT_CATEGORY.SHOES.SHOEFLATS.NAME',
    shoeHeels: 'PRODUCT_CATEGORY.SHOES.SHOEHEELS.NAME',
    shoes: 'PRODUCT_CATEGORY.SHOES.NAME',
    glasses: 'PRODUCT_CATEGORY.ACCESSORIES.GLASSES.NAME',
    bags: 'PRODUCT_CATEGORY.BAGS_LEATHER.BAGS.NAME',
    gloves: 'PRODUCT_CATEGORY.ACCESSORIES.GLOVES.NAME',
    jewelry: 'PRODUCT_CATEGORY.ACCESSORIES.JEWELRY.NAME',
    wallets: 'PRODUCT_CATEGORY.BAGS_LEATHER.WALLETS.NAME',
    scarves: 'PRODUCT_CATEGORY.ACCESSORIES.SCARVES.NAME',
    belts: 'PRODUCT_CATEGORY.BAGS_LEATHER.BELTS.NAME',
    bowTies: 'PRODUCT_CATEGORY.ACCESSORIES.BOWTIES.NAME',
    ties: 'PRODUCT_CATEGORY.ACCESSORIES.TIES.NAME',
    dressHandkerchiefs: 'PRODUCT_CATEGORY.ACCESSORIES.DRESSHANDKERCHIEFS.NAME',
    cufflinks: 'PRODUCT_CATEGORY.ACCESSORIES.CUFFLINKS.NAME',
    umbrellas: 'PRODUCT_CATEGORY.ACCESSORIES.UMBRELLAS.NAME',
    homeTextiles: 'PRODUCT_CATEGORY.HOME_AND_LIVING.HOME_TEXTILES.NAME',
    other: 'PRODUCT_CATEGORY.OTHER.NAME',
    accessories: 'PRODUCT_CATEGORY.ACCESSORIES.NAME',
    jumpsuits: 'PRODUCT_CATEGORY.CLOTHES.JUMPSUITS.NAME',
    POS: 'PRODUCT_CATEGORY.POS.NAME',
    homeLiving: 'PRODUCT_CATEGORY.HOME_AND_LIVING.NAME'
};

// Period filter values
export enum Period {
    YESTERDAY = 'range_yesterday',
    LAST_7_DAYS = 'range_7_days',
    LAST_30_DAYS = 'range_30_days',
    LAST_12_MONTHS = 'range_year',
    PREVIOUS_CALENDAR_WEEK = 'range_previous_calendar_week',
    PREVIOUS_CALENDAR_MONTH = 'range_previous_calendar_month',
    PREVIOUS_CALENDAR_YEAR = 'range_previous_calendar_year',
    ALL_PAST_DATES = 'range_all_past_dates',
    CURRENT_WEEK = 'range_current_week',
    CURRENT_MONTH = 'range_current_month',
    CURRENT_YEAR = 'range_current_year'
}

export const periodTranslationKeyMap: { [period in Period]: string } = {
    [Period.YESTERDAY]: 'PERIOD.YESTERDAY',
    [Period.LAST_7_DAYS]: 'PERIOD.LAST_7_DAYS',
    [Period.LAST_30_DAYS]: 'PERIOD.LAST_30_DAYS',
    [Period.LAST_12_MONTHS]: 'PERIOD.LAST_12_MONTHS',
    [Period.PREVIOUS_CALENDAR_WEEK]: 'PERIOD.LAST_CALENDAR_WEEK',
    [Period.PREVIOUS_CALENDAR_MONTH]: 'PERIOD.LAST_CALENDAR_MONTH',
    [Period.PREVIOUS_CALENDAR_YEAR]: 'PERIOD.LAST_CALENDAR_YEAR',
    [Period.ALL_PAST_DATES]: 'PERIOD.ALL_PAST_DATES',
    [Period.CURRENT_WEEK]: 'PERIOD.CURRENT_WEEK',
    [Period.CURRENT_MONTH]: 'PERIOD.CURRENT_MONTH',
    [Period.CURRENT_YEAR]: 'PERIOD.CURRENT_YEAR'
};
